import { render, staticRenderFns } from "./RequestConsentZaloDialog.vue?vue&type=template&id=6998f22d&scoped=true&"
import script from "./RequestConsentZaloDialog.vue?vue&type=script&lang=js&"
export * from "./RequestConsentZaloDialog.vue?vue&type=script&lang=js&"
import style0 from "./RequestConsentZaloDialog.vue?vue&type=style&index=0&id=6998f22d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6998f22d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDialog,
  VForm,
  VIcon,
  VLayout,
  VSelect,
  VSpacer,
})
